import { createReducer, on } from '@ngrx/store';

import {
  fetchMemberAppointmentsSuccess,
  fetchMemberFranchiseSuccess,
  fetchMemberPackageSuccess,
  fetchMemberProfileSuccess,
  resetMemberHubState,
} from '@hm/core/stores/member-hub/member-hub.actions';

import { ContractStatus, MemberContract } from '@lib/core/models/contract.interface';

import { MemberHubState } from '../../models/member-hub.state.interface';

const initialState: MemberHubState = {
  memberProfile: null,
  franchises: null,
  memberPackage: null,
  memberAppointments: null,
};

export const memberHubReducer = createReducer(
  initialState,
  on(fetchMemberProfileSuccess, (state, { memberProfile }) => {
    const memberContracts = [...memberProfile.contracts].sort((contract: MemberContract) => (contract.status === ContractStatus.Active ? -1 : 1));
    const updatedMemberProfile = { ...memberProfile, contracts: memberContracts };
    return {
      ...state,
      memberProfile: updatedMemberProfile,
    };
  }),
  on(fetchMemberFranchiseSuccess, (state, { franchises }) => ({
    ...state,
    franchises,
  })),
  on(fetchMemberPackageSuccess, (state, { memberPackage }) => ({
    ...state,
    memberPackage,
  })),
  on(fetchMemberAppointmentsSuccess, (state, { appointments }) => ({
    ...state,
    memberAppointments: appointments,
  })),
  on(resetMemberHubState, () => initialState)
);
